var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alwaysShow || _vm.$can('Use.TranslationEditor'))?_c('div',[_c('TranslationModeToggle',{attrs:{"title":"Shift + F7"}}),(_vm.key)?_c('TranslationEditor'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }